import type { MouseEvent, ReactNode } from 'react';
import { IconButton as BaseIconButton } from 'qampo-ui-library/base';

export type IconButtonSize = 'regular' | 'small';

interface IconButtonProps {
  icon: ReactNode;
  // Required: an icon-only control has no text, so this is its only accessible
  // name. Screen readers otherwise announce it as just "button".
  ariaLabel: string;
  size?: IconButtonSize;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  isDisabled?: boolean;
  className?: string;
}

/**
 * Icon-only button, from qampo-ui-library's `base` entry point rather than its
 * main one.
 *
 * The main export takes no aria-label at all, which is why the icon-only row
 * actions across the settings tables announce as "button" with no indication of
 * what they do or which row they belong to. The base export requires an
 * `ariaLabel` and additionally styles itself from tokens this project defines
 * (--radius-minimal, --padding-xs, --spacing-xs), where the main export reaches
 * for --border-radius-minimal, --spacing-s and --spacing-xs-md.
 */
export const IconButton = ({
  icon,
  ariaLabel,
  size = 'regular',
  onClick,
  isDisabled,
  className
}: IconButtonProps) => (
  <BaseIconButton
    icon={icon}
    ariaLabel={ariaLabel}
    size={size}
    onClick={onClick}
    disabled={isDisabled}
    classes={className}
  />
);
